import request from '../api/request'

// 登录
export function login(userinfo) {
  return request({
    url: '/login',
    method: 'post',
    data: userinfo
  })
}

// 登录注册
export function regist(registInfo) {
    return request({
      url: '/regist',
      method: 'post',
      data: registInfo
    })
}

// 查询用户列表
export function queryUserList(param) {
    return request({
      url: '/user/adminQuerylist',
      method: 'get',
      params: param
    })
}

// 根据角色查询用户
export function queryUsersByUserAndRole(param) {
    return request({
      url: '/user/queryUsersByUserAndRole',
      method: 'get',
      params: param
    })
}

// 新增用户
export function addUser(userinfo) {
    return request({
      url: '/user/addUser',
      method: 'post',
      data: userinfo
    })
}

// 修改用户信息
export function modifyUserInfo(userInfo) {
    return request({
      url: '/user',
      method: 'put',
      data: userInfo
    })
}

// 删除用户信息
export function deleteUsers(userIds) {
    return request({
      url: '/user/'+ userIds,
      method: 'delete',
    })
}

